module.exports = __webpack_public_path__ + "img/w3_trash_recover_dark.4c04d709.png";